var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "boss-accordion",
      class: [_vm.wrapClass, { "is-open": _vm.status.isOpen }],
      attrs: { "data-test": "wrap" },
    },
    [
      _c(
        "div",
        {
          staticClass: "boss-accordion-head pega-button",
          class: _vm.headClass,
          attrs: { disabled: _vm.disabled, "data-test": "head" },
          on: { click: _vm.toggle },
        },
        [_vm._t("head")],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "boss-accordion-body" }, [_vm._t("body")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }